import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function schaduwDossierReducer(state = initialState.schaduwDossier, action) {
	const model = action.body ? action.body : null;
	switch (action.type) {
		case types.SCHADUWDOSSIER_LOADED: {
			return Object.assign(
				{},
				state,
				{ model: model, finishedLoading: true }
			);
		}
		case types.SCHADUWDOSSIER_RESET: {
			return Object.assign(state, { finishedLoading: false });
		}

		default:
			return state;
	}
}
